import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    maxWidth: 450,
    overflow: 'hidden',
    [theme.breakpoints.down('xs')]: {
      maxWidth: '100%',
    },
  },
  subtitle: {
    color: theme.palette.secondary.main,
  },
  titleComponent: {
    flexDirection: 'row',
    display: 'flex',
    alignItems: 'center',
  },
  question: {
    flexDirection: 'row',
    height: '100%',
    marginBottom: 10,
    '&:last-child': {
      marginBottom: 0,
    },
  },
  cancel: {
    textTransform: 'capitalize',
    maxWidth: 450,
    width: '100%',
    fontWeight: 'normal',
    minHeight: 40,
    fontSize: 18,
    marginTop: 10,
  },
}));
